import React from 'react';

import { Typography, CountDownTimer } from '@hpstellar/core/visId';

import useDeals from '../../../hooks/useDeals';
import useCartState from '../../../hooks/useCartState';

import './order-summary-timer.less';

export default function OrderSummaryTimer() {
    const { cartInfo: { cartView: { orderItem } = {} } = {} } = useCartState();

    const deals = useDeals(orderItem);
    const dealList = Object.values(deals?.activeDeals);

    if (dealList.length < 1) {
        return null;
    }

    const timer = dealList.reduce((s, deal) => (s <= deal?.endDate ? s : deal?.endDate), dealList?.[0]?.endDate);

    return (
        <div className="order-summary-timer">
            <Typography weight={700}>YOUR OFFER EXPIRES IN </Typography>
            <CountDownTimer
                endTime={timer}
                translations={{
                    daysLabel: '',
                    hoursLabel: '',
                    minutesLabel: '',
                    secondsLabel: '',
                }}
                hideZeroValues
            />
        </div>
    );
}
